module.exports = __webpack_public_path__ + "static/img/康刻尔1.4c0e7524.png";